import React from "react";
import {Route, Routes} from "react-router-dom";
import consentModeFunctions from "../utils/consentModeFunctions";
import Forbidden from "../pages/Forbidden";
import MainHeader from "./MainHeader";
import HomeHeader from "./HomeHeader";
import HomeFooter from "./HomeFooter";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Unknown from "../pages/Unknown";
import FooterContainer from "./FooterContainer";
import Register from "../pages/Register";
import Organisations from "../pages/Organisations";
import Teams from "../pages/Teams";
import Surveys from "../pages/Surveys";
import Reports from "../pages/Reports";
import Dashboard from "../pages/Dashboard";
import Settings from "../pages/Settings";
import EditTeam from "../pages/EditTeam";
import EditOrganisation from "../pages/EditOrganisation";
import Questionnaire from "../pages/Questionnaire";
import Home from "../pages/Home"
import LearnMoreProfessional from "../pages/LearnMoreProfessional";
import LearnMoreCoaches from "../pages/LearnMoreCoaches";
import LearnMoreEnterprise from "../pages/LearnMoreEnterprise";
import Logout from "../pages/Logout";
import LoggedOut from "../pages/LoggedOut";
import Error from "../pages/Error";
import PerillModel from "../pages/PerillModel";
import PerillResources from "../pages/PerillResources";
import AboutCCMI from "../pages/AboutCCMI";
import SurveyOverview from "../pages/SurveyOverview";
import TeamCoaching from "../pages/TeamCoaching";
import GetInTouch from "../pages/GetInTouch";
import PricingPlans from "../pages/PricingPlans";
import SearchPage from "../pages/SearchPage";
import PerillHowItWorks from "../pages/PerillHowItWorks";
import EditSurvey from "../pages/EditSurvey";
import EditCoCoach from "../pages/EditCoCoach";
import TermsOfUse from "../pages/TermsOfUse";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import FAQ from "../pages/FAQ";
import StripeSuccess from "../pages/StripeSuccess";
import SettingsFlowHandler from "../pages/SettingsFlowHandler"
import Notifications from "../pages/Notifications"
import PasswordChanged from "../pages/PasswordChanged";
import ROIReport from "../pages/ROIReport";
import DiagnosticEngagement from "../pages/DiagnosticEngagement";
import FeedbackReviews from "../pages/FeedbackReviews";
import VerifyEmail from "../pages/VerifyEmail";
import CheckEmailVerification from "../utils/VerificationChecker";
import AffiliateRedirect from "../components/AffiliateRedirect";



const AppLayout = () => {

    return (
        <>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
                  integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
                  crossOrigin="anonymous"/>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js"
                    integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM"
                    crossOrigin="anonymous" />

            <Routes>

                <Route path="/ref/:affiliateName" element={
                    <AffiliateRedirect />
                }/>

                <Route exact path="/" element={
                    <>
                        <HomeHeader />
                        <Home />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/privacy" element={
                    <>
                        <HomeHeader />
                        <PrivacyPolicy />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/faq" element={
                    <>
                        <HomeHeader />
                        <FAQ />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/terms-of-use" element={
                    <>
                        <HomeHeader />
                        <TermsOfUse />
                        <HomeFooter />
                    </>
                }/>
                <Route exact path="/what-is-the-perill-model" element={
                    <>
                        <HomeHeader />
                        <PerillModel />
                        <HomeFooter />
                    </>
                }/>
                <Route exact path="/pricing-plans" element={
                    <>
                        <HomeHeader />
                        <PricingPlans />
                        <HomeFooter removeButton={true}/>
                    </>
                }/>
                <Route exact path="/get-in-touch" element={
                    <>
                        <HomeHeader />
                        <GetInTouch />
                        <HomeFooter hide_banner={true}/>
                    </>
                }/>
                <Route exact path="/team-coaching" element={
                    <>
                        <HomeHeader />
                        <TeamCoaching />
                        <HomeFooter />
                    </>
                }/>
                <Route exact path="/about-ccmi" element={
                    <>
                        <HomeHeader />
                        <AboutCCMI />
                        <HomeFooter />
                    </>
                }/>
                <Route exact path="/perill-how-it-works" element={
                   <>
                       <HomeHeader />
                       <PerillHowItWorks />
                       <HomeFooter />
                   </>
                }/>
                <Route exact path="/perill-resources" element={
                    <>
                        <HomeHeader />
                        <PerillResources />
                        <HomeFooter />
                    </>
                }/>

                <Route exact path="/verify" element={
                    <>
                        <MainHeader />
                        <VerifyEmail />
                        <FooterContainer />
                    </>
                }/>


                <Route exact path="/dashboard" element={
                    <>
                        <MainHeader />
                        <Dashboard />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/line-managers-and-hr-professionals" element={
                    <>
                        <HomeHeader />
                        <LearnMoreProfessional />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/team-coaches" element={
                    <>
                        <HomeHeader />
                        <LearnMoreCoaches />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/enterprise" element={
                    <>
                        <HomeHeader />
                        <LearnMoreEnterprise />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/organisations" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Organisations />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/organisations/:organisationId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <EditOrganisation />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/teams" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Teams />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/teams/:teamId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <EditTeam />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/feedback/:teamId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <FeedbackReviews />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/surveys" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Surveys />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/surveys/:surveyId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <EditSurvey />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>
                }/>
                <Route path="/search" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <SearchPage />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/diagnostic_summary/:surveyId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <SurveyOverview />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/reports" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Reports />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/notifications" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Notifications />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/login" element={
                    <>
                        <HomeHeader />
                        <Login />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/forgot-password" element={
                    <>
                        <HomeHeader />
                        <ForgotPassword />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/reset-password" element={
                    <>
                        <HomeHeader />
                        <ResetPassword />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/password-changed" element={
                    <>
                        <HomeHeader />
                        <PasswordChanged />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/logout" element={
                    <>
                        <Logout />
                    </>
                }/>
                <Route path="/settings-flow-handler" element={
                    <>
                        <SettingsFlowHandler />
                    </>
                }/>
                <Route path="/error" element={
                    <>
                        <HomeHeader />
                        <Error />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/logged_out" element={
                    <>
                        <HomeHeader />
                        <LoggedOut />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/register" element={
                    <>
                        <HomeHeader />
                        <Register />
                        <FooterContainer />
                    </>

                }/>
                <Route path="/settings" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Settings />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/settings/preferences" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <Settings />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/co-coach/:coCoachId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <EditCoCoach />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/questionnaire" element={
                    <Questionnaire />
                }/>
                <Route path="/forbidden" element={
                    <>
                        <HomeHeader />
                        <Forbidden />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/success" element={
                    <>
                        <HomeHeader />
                        <StripeSuccess />
                        <HomeFooter />
                    </>
                }/>
                <Route path="/roireport" element={
                    <>
                        <MainHeader />
                        <ROIReport />
                        <FooterContainer />
                    </>
                }/>
                <Route path="/roireport/:reportId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <ROIReport />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="/diagnostic_engagement/:firstSurveyId/:secondSurveyId" element={
                    <CheckEmailVerification>
                        <>
                            <MainHeader />
                            <DiagnosticEngagement />
                            <FooterContainer />
                        </>
                    </CheckEmailVerification>

                }/>
                <Route path="*" element={
                    <>
                        <HomeHeader />
                        <Unknown />
                        <FooterContainer />
                    </>
                }/>
            </Routes>


        </>

    )
}

export default AppLayout;